import { useState } from "react";
import { object, string, number, mixed } from "yup";

const useModalInformacoesAdicionais = () => {
  const validation = object({
    prazoVigenciaId: mixed()
      .test("is-object-or-personalizado", "O prazo é obrigatório", (value) => {
        return (typeof value === "object" && value !== null) || value === "personalizado";
      })
      .required("O prazo é obrigatório"),
    inicioVigencia: string()
      .required("A data de início da vigência é obrigatória")
      .matches(/^\d{4}-\d{2}-\d{2}$/, "A data de início deve estar no formato YYYY-MM-DD"),
    fimVigencia: string()
      .required("A data de fim da vigência é obrigatória")
      .matches(/^\d{4}-\d{2}-\d{2}$/, "A data de fim deve estar no formato YYYY-MM-DD")
      .test(
        "max-1-ano",
        "A data de fim deve ser no máximo 1 ano após a data de início",
        function (fim) {
          const { inicioVigencia } = this.parent;
          if (!inicioVigencia || !fim) return true;

          const inicio = new Date(inicioVigencia);
          const fimDate = new Date(fim);

          const limite = new Date(inicio);
          limite.setFullYear(limite.getFullYear() + 1);

          return fimDate <= limite;
        }
      ),
    motivoId: number().required("O motivo é obrigatório"),
    justificativa: string().required("A justificativa é obrigatória"),
  }).test("dataInicioMenorQueDataFim", "A data de início deve ser menor que a data de fim", function (value) {
    const { inicioVigencia, fimVigencia } = value;
    return new Date(inicioVigencia) < new Date(fimVigencia);
  });

  const [initial, setInitial] = useState({
    prazoVigenciaId: null,
    inicioVigencia: "",
    fimVigencia: "",
    motivoId: null,
    textoCurto: "",
    justificativa: "",
  });

  return {
    initial,
    setInitial,
    validation,
  };
};

export default useModalInformacoesAdicionais;
